import { memo } from 'react';

import InfoIconSVG from '@/assets/info-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IInfoIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={InfoIconSVG} {...props} />;

export const InfoIcon = memo(IInfoIcon) as typeof IInfoIcon;
